export const URL = '/v1/auth/login/'

export type Req = void

export type Resp = {
  is_authenticated: boolean
}
